import React, { FC, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { useMainContext } from '../../context/MainContext';
import { COLORS } from '../../utils/Colors';
import { formatByTemplate } from '../../helpers/date';

const Title = styled.span`
    font-size: 24px;
    margin-top: 30px;
    font-weight: 500px;
    
    @media screen and (max-width: 768px) {
        font-size: 20px;
        margin-top: 20px;
    }
    
    @media screen and (max-width: 480px) {
        font-size: 18px;
        margin-top: 15px;
    }
`;

const DateSpan = styled.span`
    color: ${COLORS.BLUE};
    font-size: 12px;
    font-weight: 500;

    & > span {
        color: ${COLORS.LIGHT_GRAY};
    }
    
    @media screen and (max-width: 480px) {
        font-size: 11px;
    }
`;

export const WelcomeWidget: FC = () => {
  const { profile } = useMainContext();
  const date = useRef<string>('');

  useEffect(() => {
    date.current = formatByTemplate(new Date(), 'dddd, DD MMMM YYYY');
  }, []);
  return (
    <>
      <Title>Welcome {profile?.first_name}</Title>
      <DateSpan>{date.current.split(',')[0]},
        <span>{date.current.split(',')[1]}</span>
      </DateSpan>
    </>
  );
};
